const errorMessages = {
  salesContract: {
    fileSize: 'Sales Contract file size must be greater than 0 KB and less than 100 MB.',
    fileType: 'Only .pdf, .doc, .docx, .xlsx, .xls, .tif, .tiff, .gif, .jpg, .jpeg, and .png file extensions are supported for Sales Contract.'
  }
}

export default errorMessages